import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import { withRouter } from "next/router"

import WhiteButton from '~/components/traffic-tickets/steps/WhiteButton'
import AttorneyChooseButton from '~/components/traffic-tickets/steps/AttorneyChooseButton'
import NextButton from '~/components/traffic-tickets/steps/NextButton'
import BottomButtonContainer from '~/components/traffic-tickets/steps/BottomButtonContainer'
import rightCaret from "~/public/static/images/svg/rightWhiteArrow.svg"

@inject(all => ({
  isLoading: all.store.trafficSubmission.isLoading,
  isMobile: all.store.ui.isMobile
}))
@observer
class StepBottomButtons extends Component {
  nextStep = () => {
    this.props.currentStore.nextStep()
  }

  previousStep = () => this.props.currentStore.previousStep()

  goBack = () => this.props.router.push("/traffic-tickets")

  render() {
    const { noImage, isMobile } = this.props
    const { canDisplayBackButton } = this.props.currentStore

    return (
      <BottomButtonContainer maxWidth={this.props.maxWidth}>

        {canDisplayBackButton() ? (
          <>
            <WhiteButton
              text="Back"
              onClick={this.props.currentStore.step === "violation" ? this.goBack : this.previousStep}
            />
          </>
        ) : null}

        {this.props.currentStore.step === "attorney" ||
        this.props.currentStore.storeName === "lookupStore" ? (
          <AttorneyChooseButton
            disabledText={this.props.currentStore.statusText}
            image={noImage ? null : rightCaret}
            text={this.props.nextButtonText || "Next"}
            onClick={this.nextStep}
          />
        ) : (
          <NextButton
            disabledText={this.props.currentStore.statusText}
            image={noImage ? null : rightCaret}
            text={this.props.nextButtonText || "Next"}
            onClick={this.nextStep}
            isLoading={this.props.isLoading}
            width={isMobile ? "135px" : null}
          />
        )}

      </BottomButtonContainer>
    )

  }
}

StepBottomButtons.defaultProps = {
  isSelect: false,
  selectText: 'Select'
}

StepBottomButtons.propTypes = {
  isSelect: PropTypes.bool,
  selectText: PropTypes.string
}

export default withRouter(StepBottomButtons)
